import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { insertSelectedItem } from '@atlaskit/editor-common/insert';
import { createWrapSelectionTransaction } from '@atlaskit/editor-common/utils';
import { generateSyncBlockSourceUrl } from '@atlaskit/editor-synced-block-provider';
import { findSyncBlock } from './utils/utils';
export var createSyncedBlock = function createSyncedBlock(typeAheadInsert, state, syncBlockStore) {
  var syncBlock = state.schema.nodes.syncBlock;
  var tr;
  var syncBlockNode = syncBlockStore.createSyncBlockNode();

  // If the selection is empty, we want to insert the panel on a new line
  if (state.selection.empty) {
    var node = syncBlock.createAndFill(_objectSpread({}, syncBlockNode.attrs));
    if (!node) {
      return false;
    }
    if (typeAheadInsert !== undefined) {
      // If the type-ahead insert is provided, we should use that to insert the node
      tr = typeAheadInsert(node);
    } else {
      var _insertSelectedItem;
      // Otherwise we can use insertSelectedItem to insert the node
      tr = (_insertSelectedItem = insertSelectedItem(node)(state, state.tr, state.selection.head)) === null || _insertSelectedItem === void 0 ? void 0 : _insertSelectedItem.scrollIntoView();
    }
  } else {
    tr = createWrapSelectionTransaction({
      state: state,
      type: syncBlock,
      nodeAttributes: _objectSpread({}, syncBlockNode.attrs)
    });
  }
  return tr;
};
export var copySyncedBlockReferenceToClipboard = function copySyncedBlockReferenceToClipboard(api) {
  return function (state, dispatch, _view) {
    if (!(api !== null && api !== void 0 && api.floatingToolbar) || !dispatch) {
      return false;
    }
    var syncBlock = state.schema.nodes.syncBlock,
      tr = state.tr;
    var newTr = api.floatingToolbar.commands.copyNode(syncBlock, INPUT_METHOD.FLOATING_TB)({
      tr: tr
    });
    if (!newTr) {
      return false;
    }
    dispatch(newTr);
    return true;
  };
};
export var editSyncedBlockSource = function editSyncedBlockSource(_api) {
  return function (state, _dispatch, _view) {
    var syncBlock = findSyncBlock(state);
    if (!syncBlock) {
      return false;
    }
    var url = generateSyncBlockSourceUrl(syncBlock.node);
    if (!url) {
      return false;
    }
    window.open(url, '_blank');
    return true;
  };
};
export var removeSyncedBlock = function removeSyncedBlock(api) {
  return function (state, dispatch, _view) {
    var _state$selection = state.selection,
      from = _state$selection.$from.pos,
      to = _state$selection.$to.pos,
      tr = state.tr;
    var syncBlock = findSyncBlock(state);
    if (!syncBlock) {
      return false;
    }
    if (!dispatch) {
      return false;
    }
    var newTr = tr.deleteRange(from, to);
    if (!newTr) {
      return false;
    }
    dispatch(newTr);
    api === null || api === void 0 || api.core.actions.focus();
    return true;
  };
};